export default __webpack_public_path__ + "static/media/stokerverse-rpg-qs1.ac6107db.jpg";